import { Select, SelectProps } from "@libertify/ui";
import { CaretDownIcon } from "@phosphor-icons/react";
import styled from "styled-components";

export const PlaybookSelect = (props: SelectProps) => {
  return (
    <StyledSelect
      {...props}
      // A defined suffixIcon hides antd's loading spinner.
      suffixIcon={props.loading ? undefined : <CaretDownIcon weight="bold" />}
    />
  );
};

const StyledSelect = styled(Select)`
  /* Needed to center the select icon. */
  &.ant-select {
    height: 40px !important;
  }

  .ant-select-selector {
    height: 40px !important;
  }
`;
